import * as C from '../../constants';
import SkiRestechService from '../../../../services/ski/restech-service';

export default {
  /**
   * @param commit
   */
  clearState({ commit }) {
    commit(C.SKI_RESTECH_CLEAR_STATE);
  },

  /**
   * @param commit
   * @returns {Promise<any | never>}
   */
  loadXmlChannels({ commit }) {
    commit(C.SKI_RESTECH_CHANNEL_LOAD_PENDING);
    return SkiRestechService.getXmlChannels()
      .then((res) => {
        commit(C.SKI_RESTECH_CHANNEL_LOAD_SUCCESS,
          res.data.sort((a, b) => (a.webservice > b.webservice ? 1 : -1)),
        );
      })
      .catch((err) => {
        commit(C.SKI_SKISTAR_RESORT_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param payload
   */
  setXmlChannel({ commit, state, dispatch }, payload) {
    const xmlChannel = state.xmlChannels.items.find(
      item => item.id === payload,
    );
    commit(C.SKI_RESTECH_CHANNEL_CHANGE, xmlChannel);
    dispatch('getAddonsByXmlChannelId');
  },

  /**
   * @param commit
   * @param payload
   */
  getAddonsByXmlChannelId({ commit, state }) {
    commit(C.SKI_RESTECH_CHANNEL_ADDONS_LIST_PENDING);
    return SkiRestechService.getXmlChannelAddons(state.xmlChannels.xmlChannel.id)
      .then((res) => {
        commit(C.SKI_RESTECH_CHANNEL_ADDONS_LIST_SUCCESS, res.data);
      })
      .catch((err) => {
        commit(C.SKI_RESTECH_CHANNEL_ADDONS_LIST_FAILURE, err.response.data);
      });
  },

  /**
   * @param commit
   * @param state
   * @param addon
   */
  updateAddon({ commit, state }, addon) {
    commit(C.SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_PENDING, addon.id);
    return SkiRestechService.updateAddon(addon)
      .then(() => {
        const addonIndex = state.addons.items.findIndex(item => item.id === addon.id);
        commit(C.SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_SUCCESS,
          { index: addonIndex, id: addon.id, twentyExtraId: addon.twentyExtraId });
      })
      .catch((err) => {
        commit(C.SKI_RESTECH_CHANNEL_ADDONS_TWENTY_EXTRA_UPDATE_FAILURE,
          { id: addon.id, error: err.response.data });
      });
  },

  /**
   * @param commit
   */
  showAddonAccommodationModal({ commit }, addon) {
    commit(C.SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_SHOW, addon);
  },

  /**
   * @param commit
   */
  closeAddonAccommodationModal({ commit }) {
    commit(C.SKI_RESTECH_CHANNEL_ADDONS_ACCOMMODATION_MODAL_CLOSE);
  },

  /**
   * @param commit
   * @param payload
   */
  searchAddons({ commit }, payload) {
    commit(C.SKI_RESTECH_CHANNEL_ADDONS_SEARCH, payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/restech/actions.js